






























import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";

import moment from "moment";

import MyCommon from "@/mixins/common";

@Component
export default class extends Mixins(MyCommon) {
  @Prop() stadiumId!: number;
  @Prop() is_internal!: boolean;
  @Prop() is_wechat_stadium!: boolean;
  @Prop() updateOnlineReadTime!: Function;

  online_read_time_status = false;

  async mounted() {
  }

  // 微信接单馆
  changeWechatStadiumOr(val: boolean) {
    this.showTsConfirm({
      title: "确认信息",
      content: `确定要设置为${val ? "微信接单馆" : "普通馆"}`,
      onOk: () => {

        this.$store.dispatch("stadium/wechatStadiumSetting", {
          stadium_id: this.stadiumId,
          status: val ? 1 : 0,
        });
        this.$message.success("操作成功");
        this.is_wechat_stadium = val;
      },
      onCancel: () => {
        // this.phone_status = val ? false : val;
      },
    });
  }

  // 内部馆
  changeInternalStadiumOr(val: boolean) {
    this.showTsConfirm({
      title: "确认信息",
      content: `确定要设置为${val ? "内部馆" : "一般馆"}`,
      onOk: () => {
        this.$store.dispatch("stadium/internalStadiumSetting", {
          stadium_id: this.stadiumId,
          status: val ? 1 : 0,
        });
        this.$message.success("操作成功");
        this.is_internal = val;
      },
      onCancel: () => {
        // this.phone_status = val ? false : val;
      },
    });
  }
}
